import axiosClient from "./axiosClient";

export const createPaymentOrder = async (orderId) => {
  const response = await axiosClient.post(`/payments/create-order/${orderId}`);

  return response.data;
};

export const verifyPayment = async (paymentData) => {
  const response = await axiosClient.post("/payments/verify", paymentData);

  return response.data;
};
